export const TYPES_OF_METRICS = {
  marginAndCost: {
    label: "Margin & Cost",
    value: [
      { label: "ebitda", value: "ebitda" },
      { label: "materials", value: "materials" },
      { label: "employees", value: "employees" },
      { label: "overhead", value: "overheads" },
      { label: "intTaxDep", value: "itda" },
    ],
  },
  efficiencyAndLeverage: {
    label: "Efficiency & Leverage",
    value: [
      { label: "arDays", value: "ar Days" },
      { label: "dpo", value: "dpo" },
      { label: "dii", value: "dii" },
      { label: "timesInterestEarned", value: "tie" },
      { label: "debtRatio", value: "dr" },
    ],
  },
  growthAndReturns: {
    label: "Growth & Returns",
    value: [
      { label: "revenueGrowth", value: "Revenue Growth" },
      { label: "roA", value: "roa" },
      { label: "roCE", value: "roce" },
      { label: "roE", value: "roe" },
    ],
  },
};

export const TYPES_OF_SYSTEMATIC_METRICS = {
  financingAndGrowth: {
    label: "Financing & Growth",
    value: [
      { label: "Total Shareholders Equity", value: "totalShareholdersEquity" },
      { label: "Total Debt", value: "totalDebt" },
      { label: "Total Sales", value: "totalSales" },
      { label: "Total EBITDA", value: "totalEbitda" },
    ],
  },
  assets: {
    label: "Assets",
    value: [
      { label: "Total Tangible Assets", value: "totalTangibleAssets" },
      { label: "Total Intangible Assets", value: "totalIntangibleAssets" },
      { label: "Total Financial Assets", value: "totalFinancialAssets" },
      {
        label: "Total Long Term Assets under development",
        value: "totalLongTermAssetsUnderDevelopment",
      },
    ],
  },
  costHeads: {
    label: "Cost Heads",
    value: [
      { label: "Total Materials Cost", value: "totalMaterialsCost" },
      { label: "Total Interest", value: "totalInterest" },
      { label: "Total Employee Cost", value: "totalEmployeeCost" },
      { label: "Total Tax", value: "totalTax" },
    ],
  },
  trade: {
    label: "Trade",
    value: [
      { label: "Total Working Capital", value: "totalWorkingCapital" },
      { label: "Average Inventory", value: "averageInventory" },
      { label: "Total Trade Receivables", value: "totalTradeReceivables" },
      { label: "Total Trade Payables", value: "totalTradePayables" },
    ],
  },
};

export const COLORS = {
  success: {
    bgColor: "#FFF0E2",
    textColor: "#8E3401",
  },
  warning: {
    bgColor: "#EAF4EB",
    textColor: "#0D3B14",
  },
  danger: {
    bgColor: "#FFE6E6",
    textColor: "#591111",
  },
};

export const NUMERATOR_DENOMINATOR = {
  revenueGrowth: {
    numerator:
      "Revenue from Operations of current period - Revenue from Operations of previous period",
    denominator: "Revenue from Operations of previous period",
  },
  ebitda: {
    numerator:
      "(Profit/(loss) before exceptional items and tax + Finance costs + Depreciation and amortisation expense)",
    denominator: "Revenue from Operations",
  },
  materials: {
    numerator:
      "(Cost of materials consumed + Purchase of stock-in-trade + Changes in Stock)",
    denominator: "Revenue from Operations",
  },
  employees: {
    numerator: "Employee benefit expense",
    denominator: "Revenue from Operations",
  },
  overhead: {
    numerator: "(Other expenses + Impairment Expenses/ losses)",
    denominator: "Revenue from Operations",
  },
  intTaxDep: {
    numerator:
      "(Finance costs + Depreciation and amortisation expense + Current tax - Deferred tax)",
    denominator: "Revenue from Operations",
  },
  arDays: {
    numerator:
      "(365 * ((Trade receivables of current period + Trade receivables of previous period)/2)",
    denominator: "Revenue from Operations",
  },
  dpo: {
    numerator:
      "(365 * ((Trade payables of current period + Trade payables of previous period)/2)",
    denominator:
      "(Inventories of previous period + Cost of materials consumed + Purchase of stock-in-trade + Changes in Stock - Inventories of current period)",
  },
  dii: {
    numerator:
      "(365 * ((Inventories of current period + Inventories of previous period)/2)",
    denominator:
      "(Inventories of previous period + Cost of materials consumed + Purchase of stock-in-trade + Changes in Stock - Inventories of current period)",
  },
  timesInterestEarned: {
    numerator:
      "(Profit/ loss before exceptional items and tax + Finance costs)",
    denominator: "Finance costs",
  },
  debtRatio: {
    numerator: "(Current Borrowings + Non-current Borrowings)",
    denominator: "Total Assets",
  },
  roE: {
    numerator: "Profit/ loss after tax from continuing operations",
    denominator: "Total Shareholders Equity",
  },
  roCE: {
    numerator:
      "(Profit/ loss before exceptional items and tax + Finance costs)",
    denominator: "(Total Assets - Total Current Liabilities)",
  },
  roA: {
    numerator: "Profit/ loss after tax from continuing operations",
    denominator: "Total Assets",
  },
};

// New Navigation
export const TYPES_OF_SEGMENT_METRICS = [
  {
    label: "Sales",
    value: [
      {
        label: "",
        value: [
          { label: "Total Sales", value: "totalSales" },
          { label: "Total EBITDA", value: "totalEbitda" },
        ],
      },
    ],
  },
  {
    label: "Distribution",
    value: [
      {
        label: "",
        value: [
          { label: "Total Trade Receivables", value: "totalTradeReceivables" },
          { label: "Average Inventory", value: "averageInventory" },
        ],
      },
    ],
  },
  {
    label: "Production",
    value: [
      {
        label: "",
        value: [
          { label: "Total Materials Cost", value: "totalMaterialsCost" },
          { label: "Total Trade Payables", value: "totalTradePayables" },
        ],
      },
    ],
  },
  {
    label: "Operations",
    value: [
      {
        label: "",
        value: [
          { label: "Total Tangible Assets", value: "totalTangibleAssets" },
          { label: "Total Intangible Assets", value: "totalIntangibleAssets" },
          {
            label: "Total Long Term Assets under development",
            value: "totalLongTermAssetsUnderDevelopment",
          },
        ],
      },
    ],
  },
  {
    label: "HR",
    value: [
      {
        label: "",
        value: [{ label: "Total Employee Cost", value: "totalEmployeeCost" }],
      },
    ],
  },
  {
    label: "Finance",
    value: [
      {
        label: "",
        value: [
          { label: "Total Working Capital", value: "totalWorkingCapital" },
          { label: "Total Financial Assets", value: "totalFinancialAssets" },
          { label: "Total Interest", value: "totalInterest" },
          { label: "Total Tax", value: "totalTax" },
          { label: "Total Debt", value: "totalDebt" },
          {
            label: "Total Shareholders Equity",
            value: "totalShareholdersEquity",
          },
        ],
      },
    ],
  },
];


export const COLORS_COMPETATIVE_METRICS = {
  relativeMarketShare: {
    selected: { textColor: "#2D6C08", bgColor: "#E4F0DD" },
    unselected: { textColor: "#2D6C08", bgColor: "#E4F0DD" },
  },
  revenueGrowth: {
    selected: { textColor: "#BE4400", bgColor: "#FFF1E1" },
    unselected: { textColor: "#BE4400", bgColor: "#FFF1E1" },
  },
  ebitda: {
    selected: { textColor: "#B31B1B", bgColor: "#FDE7E7" },
    unselected: { textColor: "#B31B1B", bgColor: "#FDE7E7" },
  },
  roE: {
    selected: { textColor: "#2D6C08", bgColor: "#E4F0DD" },
    unselected: { textColor: "#2D6C08", bgColor: "#E4F0DD" },
  },
  fixedAssetTurnoverRatio: {
    selected: { textColor: "#BE4400", bgColor: "#FFF1E1" },
    unselected: { textColor: "#BE4400", bgColor: "#FFF1E1" },
  },
  arDays: {
    selected: { textColor: "#2D6C08", bgColor: "#E4F0DD" },
    unselected: { textColor: "#2D6C08", bgColor: "#E4F0DD" },
  },
  dii: {
    selected: { textColor: "#BE4400", bgColor: "#FFF1E1" },
    unselected: { textColor: "#BE4400", bgColor: "#FFF1E1" },
  },
  employees: {
    selected: { textColor: "#2D6C08", bgColor: "#E4F0DD" },
    unselected: { textColor: "#2D6C08", bgColor: "#E4F0DD" },
  },
  materials: {
    selected: { textColor: "#BE4400", bgColor: "#FFF1E1" },
    unselected: { textColor: "#BE4400", bgColor: "#FFF1E1" },
  },
  dpo: {
    selected: { textColor: "#B31B1B", bgColor: "#FDE7E7" },
    unselected: { textColor: "#B31B1B", bgColor: "#FDE7E7" },
  },
  overhead: {
    selected: { textColor: "#2D6C08", bgColor: "#E4F0DD" },
    unselected: { textColor: "#2D6C08", bgColor: "#E4F0DD" },
  },
  roA: {
    selected: { textColor: "#BE4400", bgColor: "#FFF1E1" },
    unselected: { textColor: "#BE4400", bgColor: "#FFF1E1" },
  },
  WorkingCapitalRatio: {
    selected: { textColor: "#2D6C08", bgColor: "#E4F0DD" },
    unselected: { textColor: "#2D6C08", bgColor: "#E4F0DD" },
  },
  timesInterestEarned: {
    selected: { textColor: "#BE4400", bgColor: "#FFF1E1" },
    unselected: { textColor: "#BE4400", bgColor: "#FFF1E1" },
  },
  intTaxDep: {
    selected: { textColor: "#B31B1B", bgColor: "#FDE7E7" },
    unselected: { textColor: "#B31B1B", bgColor: "#FDE7E7" },
  },
  debtRatio: {
    selected: { textColor: "#2D6C08", bgColor: "#E4F0DD" },
    unselected: { textColor: "#2D6C08", bgColor: "#E4F0DD" },
  },
  roCE: {
    selected: { textColor: "#BE4400", bgColor: "#FFF1E1" },
    unselected: { textColor: "#BE4400", bgColor: "#FFF1E1" },
  },
  WorkingCapitalSalesRatio: {
    selected: { textColor: "#B31B1B", bgColor: "#FDE7E7" },
    unselected: { textColor: "#B31B1B", bgColor: "#FDE7E7" },
  },
};

export const TYPES_OF_COMPETATIVE_METRICS = [
  {
    label: "Topline",
    value: [
      {
        label: "Sales",
        value: [
          
          {
            label: "Relative Market Share",
            value: "relativeMarketShare",
          },
          {
            label: "Revenue Growth",
            value: "revenueGrowth",
          },
          {
            label: "EBITDA %",
            value: "ebitda",
          },
          {
            label: "ROE",
            value: "roE",
          },
          {
            label: "Fixed Asset Turnover Ratio",
            value: "fixedAssetTurnoverRatio",
          },
        ],
      },
      {
        label: "Distribution",
        value: [
          // DRO === arDays
          {
            label: "DRO",
            value: "arDays",
          },
          // DIO === dii
          {
            label: "DIO",
            value: "dii",
          },
        ],
      },
    ],
  },
  {
    label: "Bottomline",
    value: [
      {
        label: "HR",
        value: [{ label: "Employees %", value: "employees" }],
      },
      {
        label: "Production",
        value: [
          {
            label: "Materials %",
            value: "materials",
          },
          {
            label: "DPO",
            value: "dpo",
          },
        ],
      },
      {
        label: "Operations",
        value: [
          {
            label: "Overheads %",
            value: "overhead",
          },
          {
            label: "ROA",
            value: "roA",
          },
        ],
      },
    ],
  },
  {
    label: "Financing",
    value: [
      {
        label: "Finance",
        value: [
          {
            label: "Working Capital Ratio",
            value: "WorkingCapitalRatio",
          },
          {
            label: "TIE",
            value: "timesInterestEarned",
          },
          {
            label: "ITDA %",
            value: "intTaxDep"
          },
          {
            label: "DR",
            value: "debtRatio",            
          },
          {
            label: "ROCE",
            value: "roCE",            
          },
          {
            label: "Working Capital to Sales Ratio",
            value: "WorkingCapitalSalesRatio"            
          },
        ],
      },
    ],
  },
];
